import type { Styling } from 'src/context/styling';
import { BuildType } from 'src/enums/build/build-type';

export const getFooterColors = (styling: Styling, buildType: BuildType) => {
  const defaultColors = {
    backgroundColor: styling.colors.greyBackground,
    heading: styling.colors.capeCod,
    text: styling.colors.capeCod,
    textHighlight: styling.colors.camelot,
    border: styling.colors.transparentGreenGrey,
  };

  switch (buildType) {
    case BuildType.HARBOUR: {
      return { ...defaultColors, textHighlight: styling.colors.highlightText };
    }
    case BuildType.MERIDIAN: {
      return {
        backgroundColor: styling.colors.greyBackground,
        heading: styling.colors.capeCod,
        text: styling.colors.capeCod,
        textHighlight: styling.colors.meridianBlue,
        border: styling.colors.transparentGrayOlive,
      };
    }
    default: {
      return defaultColors;
    }
  }
};
